import React from 'react';

const github = (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
             viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}}>
        <g id="OUTLINE_copy">
            <path className="p1" id="Cat_4_" d="M18.52,24.493h-2.263h-2.265c0,0,0.006-1.344,0-2.265
                c-3.099,0.667-3.964-1.699-3.964-1.699c-0.566-1.132-1.132-1.699-1.132-1.699c-1.132-0.673,0-0.566,0-0.566
                c1.132,0,1.699,1.132,1.699,1.132c0.994,1.687,2.762,1.416,3.397,1.132c0-0.566,0.248-1.422,0.566-1.699
                c-2.473-0.279-4.532-1.699-4.532-4.53s0.568-3.397,1.135-3.964c-0.114-0.279-0.588-1.311,0.018-2.831c0,0,1.113,0,2.245,1.699
                c0.561-0.561,2.265-0.566,2.832-0.566c0.565,0,2.269,0.005,2.83,0.566c1.132-1.699,2.248-1.699,2.248-1.699
                c0.605,1.52,0.132,2.552,0.017,2.831c0.566,0.566,1.132,1.132,1.132,3.964s-2.056,4.251-4.53,4.53
                c0.319,0.276,0.566,1.251,0.566,1.699L18.52,24.493L18.52,24.493z"/>
        </g>
        </svg>)

export default github;



// WEBPACK FOOTER //
// ./src/components/Websites/About/SVGs/github.js